import React from "react";
import { useState, useEffect } from "react";
import classes from "./PrepareLoading.module.scss";
import charLoading from "../../static/images/Loading.png";
import headerImage from "../../static/images/prepare-header.png";

const PrepareLoading = () => {
  const [dot, setDot] = useState("");

  useEffect(() => {
    // ドットのアニメーションを開始
    const intervalId = setInterval(() => {
      setDot((prevDot) => (prevDot.length < 3 ? prevDot + "・" : ""));
    }, 1000); // 3秒間で全てのコマを表示

    // コンポーネントのクリーンアップ関数
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, []);

  return (
    <>
      <div className={classes.loadingContainer}>
        <div className={classes.questionHeaderContainer}>
          <img src={headerImage} alt={headerImage} className={classes.image} />
        </div>
        <div className={classes.logoImageContainer}>
          <img src={charLoading} alt={charLoading} />
        </div>
        <svg
          className={classes.dots}
          xmlns="http://www.w3.org/2000/svg"
          width="69"
          height="40"              // ← 高さを25→40に広げる
          viewBox="0 0 69 40"      // ← viewBox も合わせて広げる
          aria-hidden="true"
        >
          <circle cx="12.5" cy="20" r="6.5" />  {/* Y座標を少し下げる */}
          <circle cx="34.5" cy="20" r="6.5" />
          <circle cx="56.5" cy="20" r="6.5" />
        </svg>
        <p className={classes.message}>結果を作成中です<br />少々お待ちください</p>
      </div>
    </>
  );
};

export default PrepareLoading;
